import { createContext, useCallback, useState } from 'react';
import { WithChildren } from 'types/component';
import { useContext } from 'react';
import { useTimer } from 'hooks/useTimer';

const INITIAL_TIMER = 0;

interface HoldTokenSessionTimerContextProps {
  resetTimer: (seconds: number) => void;
  holdTokenSessionTimer: number;
  hasTimerBeenSet: boolean;
}

export const HoldTokenSessionTimerContext = createContext<
  HoldTokenSessionTimerContextProps | undefined
>(undefined);

export const HoldTokenSessionTimerProvider = ({ children }: WithChildren) => {
  const [hasTimerBeenSet, setHasTimerBeenSet] = useState(false);
  const { timer: holdTokenSessionTimer, resetTimer: resetTimerFromHook } = useTimer(INITIAL_TIMER);

  const resetTimer = useCallback(
    (seconds: number) => {
      setHasTimerBeenSet(true);
      resetTimerFromHook(seconds);
    },
    [resetTimerFromHook],
  );

  return (
    <HoldTokenSessionTimerContext.Provider
      value={{
        holdTokenSessionTimer,
        resetTimer,
        hasTimerBeenSet,
      }}
    >
      {children}
    </HoldTokenSessionTimerContext.Provider>
  );
};

export const useHoldTokenSessionTimerContext = () => {
  const context = useContext(HoldTokenSessionTimerContext);

  if (context === undefined) {
    throw new Error('HoldTokenSessionTimerContext is undefined');
  }

  return context;
};
